import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions/index';
import {getData, LOGIN} from "../../util/storage";
import {isEmpty} from "../../util/utility";
import ReactPaginate from 'react-paginate';
import Calendar from 'react-calendar';
import * as _ from 'lodash';

//image
import ContentLoader from "react-content-loader";
import loading_white from "../../assets/gif/loading_white.gif";
import MessageUser from "../../components/MessageUser";

class Wallet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageCount:1,
            currentPage:1,
            totalEarnings:"...",
            currency_symbol:"",
            earningsList:[],
            showFromCalendar: false,
            showToCalendar: false,
            fromDate: "",
            toDate: "",
            // fromDate: new Date(),
            // toDate: new Date(),
        }
    }

    /**
     * @function is invoked immediately after a component is mounted. Initialization that requires DOM nodes should go here.
     * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
     */
    componentDidMount() {
        getData(LOGIN)
            .then((data) => {
                if(!isEmpty(data)){
                    this.props.getMyEarnings(data.token, data.api_token, "", "", 1)
                }
            })
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        //check if we have user information
        if (nextProps.broadcaster_get_my_earnings !== null &&
            nextProps.broadcaster_get_my_earnings.hasOwnProperty("payload") &&
            nextProps.broadcaster_get_my_earnings.payload !== null
        ) {
            const payload = nextProps.broadcaster_get_my_earnings.payload;
            this.setState({
                pageCount:payload.last_page,
                currentPage:payload.current_page,
                totalEarnings:payload.total_earnings,
                currency_symbol:payload.currency_symbol,
                earningsList:payload.data

            })
            //console.log(payload.data)
            this.props.resetEarnings();
        }

        if (nextProps.hasOwnProperty("broadcaster_send_message") &&
            nextProps.broadcaster_send_message.hasOwnProperty("messageModal") &&
            nextProps.broadcaster_send_message.messageModal !== null &&
            nextProps.broadcaster_send_message.messageModal !== undefined) {
            //console.log(nextProps.broadcaster_send_message.messageModal)
            const data = nextProps.broadcaster_send_message.messageModal
            // this.setState({data});
            this.setState({
                isVisible : true,
                userDataForMessage: nextProps.broadcaster_send_message.messageModal.userData,
                messageAllData: nextProps.broadcaster_send_message.messageModal.messageAllData
            })
            this.props.hideMessageModal()
        }
    }

    /**
     * @function This is invoked when an page number is clicked .
     * @param data
     */
    handlePageClick = (data) => {

        //console.log(data)
        let selected = data.selected;
        //console.log(selected)
        getData(LOGIN)
            .then((data) => {
                if(!isEmpty(data)){
                    this.setState({
                        earningsList:[]
                    })
                    this.props.getMyEarnings(data.token, data.api_token, "", "", selected+1)
                }
            })
    }

    toggleFromCalendar = () => {
        this.setState({
            showFromCalendar: !this.state.showFromCalendar,
            showToCalendar:false
        })
    }

    toggleToCalendar = () => {
        this.setState({
            showToCalendar: !this.state.showToCalendar,
            showFromCalendar:false
        })
    }

    onFromDateChange = fromDate => {
        this.setState({ fromDate })
        this.toggleFromCalendar()
    }

    getFormattedDate = date => {
        // return date ? `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}` : ""
        return date ? `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}` : ""

    }

    onToDateChange = toDate => {
        this.setState({ toDate })
        this.toggleToCalendar()
    }

    clickedOnSearch = () => {
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.getMyEarnings(data.token, data.api_token, this.getFormattedDate(this.state.fromDate), this.getFormattedDate(this.state.toDate), 1)

                }
            })
    }

    clickedOnClear = () => {

        this.setState({
            toDate:"",
            fromDate:""
        })
        getData(LOGIN)
            .then((data) => {
                if(!isEmpty(data)){
                    this.props.getMyEarnings(data.token, data.api_token, "", "", 1)
                }
            })
    }

    toggleVisibilityOfMessage = () => {
        this.setState({ isVisible: !this.state.isVisible})
    }

    getType = (data)=>{
        if(data.broadcast_id !== null){
            return data.type === "paid_group" ? "Group" : "Private";
        }else{
            return _.capitalize(data.clipstore_type);
        }
    }

    render() {

        return (
            <div>
                <main role="main" className="broadcast-container-parent row">
                    <div className="broadcast-container my-earnings broadcast-type">
                        <div className="title-container">
                            <div><h4>My Earnings</h4></div>
                        </div>
                        <div className="wrapper">
                        <div class="message-wrapper" style={{ display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'}}
                               >
                                   <div style={{ fontSize: '1.125rem',fontWeight: 'bold'}}>
                                       Available funds: £{this.state.totalEarnings}
                                    </div>
                                    <div>
                                        <a href="mailto:support@vuepay.com?body=Hello,%0D%0A%0D%0AKindly request you to payout the monies for my account." title="Contact us" class="btn btn-primary" style={{alignItems: 'flex-end'}}>Request Payout</a>
                                    </div>
                        </div>
                        
                            <p>Your earnings will be deposited into your bank account on the first day of each month</p>
                            <p className="mt-4"><strong>Search for session earnings</strong></p>

                            <form>
                                <div className="row mb-4">
                                    <div className="col-lg-7 col-md-7">
                                        <div className="form-group calendar">
                                            <label className="col-form-label">From</label>
                                            <div className="input-group">
                                                <input type="text" className="form-control" value={this.getFormattedDate(this.state.fromDate)}/>
                                                <div className="input-group-append">
                                                    <button className="btn btn-calendar" type="button" onClick={this.toggleFromCalendar}>calendar</button>
                                                </div>

                                            </div>
                                            {this.state.showFromCalendar && <div style={{position:'absolute'}}>
                                                <Calendar
                                                    onChange={this.onFromDateChange}
                                                    value={this.state.fromDate}
                                                />
                                            </div>}
                                        </div>

                                        <div className="form-group calendar">
                                            <label className="col-form-label">To</label>
                                            <div className="input-group">
                                                <input type="text" className="form-control" value={this.getFormattedDate(this.state.toDate)}/>
                                                <div className="input-group-append">
                                                    <button className="btn btn-calendar" type="button" onClick={this.toggleToCalendar}>calendar</button>
                                                </div>
                                            </div>
                                            {this.state.showToCalendar && <div style={{position:'absolute'}}>
                                                <Calendar
                                                    onChange={this.onToDateChange}
                                                    value={this.state.toDate}
                                                />
                                            </div>}
                                        </div>
                                    </div>
                                    {(this.getFormattedDate(this.state.fromDate).length > 0 && this.getFormattedDate(this.state.toDate).length > 0) && <div className="col-lg-5 col-md-5">
                                        {this.props.broadcaster_get_my_earnings.isFetching ?
                                            <button className="btn btn-outline-primary" type="button">
                                                <img src={loading_white} alt={"Loading"} width={26} height={26}/>
                                            </button>
                                            :
                                            <button className="btn btn-outline-primary"
                                                    onClick={this.clickedOnSearch}>Search</button>
                                        }

                                        <button className="btn btn-outline-primary" onClick={this.clickedOnClear}>Clear</button>
                                    </div>}
                                </div>
                            </form>

                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Date</th>
                                    <th scope="col">Session title</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Earnings</th>
                                    <th scope="col">Status <button type="button" className="btn arrow-blue-up"></button>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.earningsList && this.state.earningsList.length > 0 && _.map(this.state.earningsList, (data,index) => {

                                        return <tr key={index}>
                                            <th scope="row">{data.start_date}</th>
                                            <td>{data.session_title}</td>
                                            <td>{this.getType(data)}</td>
                                            <td>{`${this.state.currency_symbol}${data.amount}`}</td>
                                            <td>{data.status_to_broadcaster === "0" ? "Pending" : <span className="text-success">Paid</span>}</td></tr>
                                    })
                                }
                                </tbody>
                            </table>

                            {(this.props.broadcaster_get_my_earnings.isFetching && this.state.earningsList.length === 0)
                            ?
                            <ContentLoader
                                height={240}
                                speed={1}
                                primaryColor="#f3f3f3"
                                secondaryColor="#ecebeb"
                            >
                                <rect x="12" y="10" rx="4" ry="4" width="300" height="10"/>
                                <rect x="12" y="30" rx="4" ry="4" width="300" height="10"/>
                                <rect x="12" y="50" rx="4" ry="4" width="300" height="10"/>
                                <rect x="12" y="70" rx="4" ry="4" width="300" height="10"/>
                            </ContentLoader>
                            :
                            this.state.earningsList.length > 0 && <ReactPaginate previousLabel={"Previous"}
                                           previousClassName={"page-item prev"}
                                           previousLinkClassName={"page-link"}
                                           nextLinkClassName={"page-link"}
                                           nextLabel={"Next"}
                                           nextClassName={"page-item next"}
                                           breakLabel={<a href="">...</a>}
                                           breakClassName={"break-me page-link"}
                                           pageCount={this.state.pageCount}
                                           marginPagesDisplayed={this.state.pageCount}
                                           pageRangeDisplayed={this.state.pageCount}
                                           pageClassName={"page-item"}
                                           pageLinkClassName={"page-link"}
                                           onPageChange={this.handlePageClick}
                                           containerClassName={"pagination justify-content-end"}
                                           forcePage={this.state.currentPage-1}
                                           activeClassName={"active"}
                                            />}
                        </div>
                    </div>
                    <MessageUser isVisible={this.state.isVisible} userData={this.state.userDataForMessage} messageAllData={this.state.messageAllData} closeMessage={this.toggleVisibilityOfMessage}/>
                </main>

            </div>
        );
    }
}


function mapStateToProps(state, ownParams) {
        return {
            broadcaster_get_my_earnings: state.broadcaster_get_my_earnings,
            broadcaster_send_message: state.broadcaster_send_message
        }
};

export default connect(mapStateToProps, actions)(Wallet)